import type { ServiceCaseCategory } from '../../../shared/types'

const categoryStyles: Record<ServiceCaseCategory, string> = {
  part_request: 'bg-purple-100 text-purple-700',
  error_code: 'bg-red-100 text-red-700',
  maintenance: 'bg-blue-100 text-blue-700',
  documentation: 'bg-cyan-100 text-cyan-700',
  other: 'bg-gray-100 text-gray-600',
}

const categoryLabels: Record<ServiceCaseCategory, string> = {
  part_request: 'Part Request',
  error_code: 'Error Code',
  maintenance: 'Maintenance',
  documentation: 'Documentation',
  other: 'Other',
}

export function ServiceCaseCategoryBadge({ category }: { category: ServiceCaseCategory }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${categoryStyles[category]}`}>
      {categoryLabels[category]}
    </span>
  )
}
